import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import { htmlTemplatePrintListaRecurrente } from '../../../../libs/services';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');

class Recurrent_donors extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.setTable = this.setTable.bind(this);
        this.searching = this.searching.bind(this);

        this.state ={
		start_date:"",
		end_date:"",
		filename:"Donadores Recurrentes",
		columns:[
			{title:'Donor id'},
			{title:'N° Última Donación'},
			{title:'F. última Donación'},
			{title:'Nombre del Donador'},
			{title:'F. de Nacimiento'},
			{title:'Tipo de Donación'},
			{title:'Tipo de Extracción'},
			{title:'Sexo'},
			{title:'Dirección'},
			{title:'Reactivo'}
		],
		listado:[],
		count:0
				}
    }
    componentWillMount(){
        var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});
    }
    componentDidMount(){
        
        this.setTable();
    }
    handleChange(){}
    setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			aoColumnDefs: [
				{ "sWidth": "200px", "aTargets": [0] },
			   	{ "sWidth": "100px", "aTargets": [1,2,4,6,8] },
			],
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
					messageBottom: 'Total de registros: ' + this.state.count,
					className: 'btn btn-success', 
                	text: '<i class="fa fa-file-excel-o"></i> Excel'
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

                		doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
						doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};

						doc.content.push({
							text: 'Total de registros: ' + this.state.count,
							margin: [0, 10, 0, 0], // Margen superior para que no pegue a la tabla
							bold: true,
							fontSize: 10
						});

                	} 
            	}
            ],
            columnDefs: [{
		        targets: [3,4,5,9],
		        className: 'dt-center'
    		}],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: true,
			info:false,
			ordering:false
			
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}
    searching(e){
        e.preventDefault();
        var contador =0;
        if (this.state.start_date!="" ) {
            contador --
            document.getElementById('start_date').classList.remove('error');
        }else{
            contador++
            document.getElementById('start_date').classList.add('error');
        }
        if (this.state.end_date!="" ) {
            contador --
            document.getElementById('end_date').classList.remove('error');
        }else{
            contador++
            document.getElementById('end_date').classList.add('error');
        }
        if (contador<0) {
            this.props.waiting.handleShow('Buscando...');
            var obj={};
        obj.fechadesde=this.state.start_date;
        obj.fechahasta = this.state.end_date;
        fetch(Config.default.apiGateway.URL+'/reports/recurrent_donors',{
            method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
                    if (response!= undefined) {
                        console.log(response);
						
						let dataForTable = response.map(r => [
							r.donor_id,
							r.numeroUltimaDonacion,
							r.fechaUltimaDonacion,
							r.nombreDonador,
							r.fechaNacimiento,
							r.tipoDonacion,
							r.tipoExtraccion,
							r.sexo,
							r.direccion,
							r.Reactivo
						]);


                        this.setState({
                            listado: dataForTable,
							count:response.length
                        });
						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
												
                        this.props.waiting.handleClose();
                    }else{
                        this.props.waiting.handleClose();
                        swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
                    }
                })
                this.props.waiting.handleClose();
        }else{
            swal('Error', 'Fecha obligatoria', 'error');
        }
       
    }
    handleChange(e){
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    async onPrint(e,events){
		e.preventDefault();
		console.log(events);
		var response = await htmlTemplatePrintListaRecurrente(events,sessionStorage.getItem('health_facilities_id'));
		if (response != undefined) {
			var fileURL = URL.createObjectURL(response);
		window.open(fileURL);
		}
	}
    render(){
        const {t} = this.props;
        return(
            <div className="col-xs-12">
                <div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{this.state.filename}
					</h5>
				</div>
                <div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="col-xs-12 form-group" >
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="col-xs-12 form-group" >
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>
								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										
									</div>
								</div>                               
								
								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}}  id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
                               

								{<div className="col-xs-12">
									<span>Total de registros: </span>
									<label style={{marginLeft:'5px'}}>{this.state.count}</label>
								</div>}
							</div>
						</form>
					</div>
				</div>
            </div>
        );
    }
}
export default translate('translations') (Recurrent_donors);